import React, { useRef } from "react";
import { FaPaperclip } from "react-icons/fa";
import { toast } from "react-toastify";
import "./attachmentStyles.css";

const AttachmentButton = ({
  onAttachmentSelect,
  maxFileSize = 5,
  allowedTypes = ["image/*", ".pdf", ".doc", ".docx", ".txt"],
}) => {
  const fileInputRef = useRef(null);

  const handleClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files || []);

    // Validate file size
    const oversizedFiles = files.filter(
      (file) => file.size > maxFileSize * 1024 * 1024
    );
    if (oversizedFiles.length > 0) {
      toast.error(
        `Some files exceed the ${maxFileSize}MB limit and were not added`
      );
    }

    // Filter out oversized files
    const validFiles = files.filter(
      (file) => file.size <= maxFileSize * 1024 * 1024
    );

    onAttachmentSelect(validFiles);

    // Reset input to allow selecting the same file again
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  return (
    <div className="attachment-button-container">
      <button
        type="button"
        onClick={handleClick}
        className="attachment-button"
        aria-label="Attach files"
      >
        <FaPaperclip size={18} />
      </button>
      <input
        ref={fileInputRef}
        type="file"
        multiple
        accept={allowedTypes.join(",")}
        onChange={handleFileChange}
        className="hidden-input"
      />
    </div>
  );
};

export default AttachmentButton;
